import React, { useEffect, useState, useRef } from 'react';
import Carousel from 'react-material-ui-carousel'
import { Paper, withStyles } from '@material-ui/core'
import Rating from '@material-ui/lab/Rating';


import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import GradeIcon from '@material-ui/icons/Grade';
import './style.css';
import { SERVER_URL } from '../../utils';

const StyledRating = withStyles({
  root: {
    fontSize: '1.3em'
  },
  iconFilled: {
    color: '#ffff01',
  },
  iconHover: {
    color: '#ffff01',
  },
})(Rating);


const ProductReviews = (props) => {
  const [reviews, setReviews] = useState([]);
  const navRef = useRef(null);

  console.log("REVIEW", props.productID);
  console.log("REVIEW", reviews);

  useEffect(() => {
      setReviews([]);
      if (props.productID) {
        fetch(`${SERVER_URL}/wp-json/anyrace_product_list/reviews/${props.productID}`)
        .then((res) => res.json())
        .then((o) => {
          setReviews(
            o.map((a) => ({
              reviewer: a.comment_author,
              review: a.comment_content,
              rating: a.rating,
              productID: a.comment_post_ID
            }))
          );
        });
        
      }
    }, [props.productID]);
  
    
  
    if (!props.productID) {
      return <></>;
    }
    return (
      (reviews.length > 0 ) && (
        <div className="reviews">
        <h3 className="review-name">Reviews</h3>
          <Carousel className="review"
            navButtonsAlwaysVisible
            navButtonsAlwaysInvisible={ !(reviews.length > 1) }
            indicators={false}
            autoPlay={false}>
        {reviews
            .filter((r) => props.productID !== '')
            .map((entry, index) => (
              <div key={index} className="inner-review">
                <div className="review-stars">
                  <StyledRating
                    name="read-only"
                    value={entry.rating}
                    icon={<GradeIcon styles={{ strokeColor: 'black' }} fontSize="inherit" />}
                    readOnly
                  />
                </div>
                <div className="review-content">&quot;{
                  // Limit this to 114 lines.
                  (entry.review).length > 114 ? `${(entry.review).substr(0, 114)}...` : entry.review
                }&quot;</div>
                <div className="reviewer-name">{entry.reviewer}</div>
              </div>
            ))}
        </Carousel>
    </div>)
    );
}
  
export default ProductReviews